import React, { useState, useEffect } from 'react'
import {
  Box,
  Stack,
  Typography,
  OutlinedInput,
  InputAdornment,
  Button,
  CircularProgress,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import AddIcon from '@mui/icons-material/Add'
import { DispatchStatusTable } from '../../components/Table/DispatchStatusTable'
import { IDispatchStatus } from '../../types/dispatchStatus'
import { useGetDispatchStatusListQuery } from '../../redux/api/dispatchStatusApi'
import { DispatchStatusForm } from './DispatchStatusForm'

const styles = {
  container: {
    padding: '32px 24px 64px',
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  searchInput: {
    width: '100%',
    marginRight: '10px',
  },
  addButton: {
    textTransform: 'none',
    textDecoration: 'none',
  },
}

export const DispatchStatusPage = () => {
  const [searchKey, setSearchKey] = useState('')
  const [editingStatus, setEditingStatus] = useState<IDispatchStatus | null>(null)
  const { data, isLoading, refetch } = useGetDispatchStatusListQuery(null)

  useEffect(() => {
    refetch()
  }, [refetch])

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchKey(event.target.value)
  }

  const handleEditStatus = (status: IDispatchStatus) => {
    setEditingStatus(status)
  }

  const handleCloseForm = () => {
    setEditingStatus(null)
    refetch()
  }

  const handleAddStatus = () => {
    setEditingStatus({} as IDispatchStatus)
  }

  return (
    <Box sx={styles.container}>
      <Stack direction='row' justifyContent='space-between' mb={2} mr={1}>
        <Typography variant='h4' color='#1E90FF'>
          Flight Tracker Dispatch Statuses
        </Typography>
        <Stack direction='row' alignItems='center'>
          <OutlinedInput
            placeholder='Search'
            onChange={handleSearchChange}
            endAdornment={
              <InputAdornment position='end'>
                <SearchIcon />
              </InputAdornment>
            }
            sx={{ marginRight: '20px' }}
          />
          <Button
            variant='outlined'
            sx={{ borderRadius: '20px', height: '40px', textDecoration: 'none' }}
            startIcon={<AddIcon />}
            onClick={handleAddStatus}
            size='medium'
          >
            Create
          </Button>
        </Stack>
      </Stack>
      {isLoading ? (
        <Box
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <DispatchStatusTable
          isLoading={isLoading}
          rows={data || []}
          searchKey={searchKey}
          editStatus={handleEditStatus}
          refetch={refetch}
        />
      )}
      {editingStatus && (
        <DispatchStatusForm
          data={editingStatus}
          onClose={handleCloseForm}
          refetch={refetch}
          open={!!editingStatus}
        />
      )}
    </Box>
  )
}
